import { render, staticRenderFns } from "./SoilCropForm.vue?vue&type=template&id=4b949349"
import script from "./SoilCropForm.vue?vue&type=script&lang=js"
export * from "./SoilCropForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports